import { z } from 'zod';
import { McpChallengeState, McpDeviceInfoSchema } from './challenge.js';
/**
 * Not {@link McpChallengeState}: `Expired` is a deadline rather than a stored
 * transition, and `Issued` happens on the one poll that consumes the challenge.
 */
export var McpRedemptionStatus;
(function (McpRedemptionStatus) {
    McpRedemptionStatus["Pending"] = "Pending";
    McpRedemptionStatus["Denied"] = "Denied";
    McpRedemptionStatus["Expired"] = "Expired";
    McpRedemptionStatus["Consumed"] = "Consumed";
    McpRedemptionStatus["Issued"] = "Issued";
})(McpRedemptionStatus || (McpRedemptionStatus = {}));
const McpUserCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .transform((value) => value.replaceAll('-', ''))
    .pipe(z.string().regex(/^[23456789CDFGHJKMNPQRTVWXY]{8}$/))
    .transform((value) => `${value.slice(0, 4)}-${value.slice(4)}`);
const McpDeviceCodeSchema = z
    .string()
    .length(43)
    .regex(/^[A-Za-z0-9_-]+$/);
export const ReadMcpChallengeBodySchema = z
    .object({
    userCode: McpUserCodeSchema,
})
    .strict();
export const CreateMcpChallengeBodySchema = z
    .object({
    deviceInfo: McpDeviceInfoSchema,
})
    .strict();
export const CreateMcpChallengeResponseSchema = z.object({
    deviceCode: McpDeviceCodeSchema,
    userCode: McpUserCodeSchema,
    approvalUrl: z.url(),
    expiresAt: z.iso.datetime(),
});
export const ReadMcpChallengeResponseSchema = z.object({
    claimedDeviceInfo: McpDeviceInfoSchema,
    observedIp: z.union([z.ipv4(), z.ipv6()]),
    requestedAt: z.iso.datetime(),
    expiresAt: z.iso.datetime(),
});
export const McpChallengeDecisionSchema = z
    .object({
    userCode: McpUserCodeSchema,
    state: z.enum([McpChallengeState.Approved, McpChallengeState.Denied]),
})
    .strict();
export const McpChallengeDecisionResponseSchema = z
    .object({
    state: z.enum([McpChallengeState.Approved, McpChallengeState.Denied]),
})
    .strict();
export const RedeemMcpChallengeBodySchema = z
    .object({
    deviceCode: McpDeviceCodeSchema,
})
    .strict();
export const RedeemMcpChallengeResponseSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal(McpRedemptionStatus.Issued),
        credential: z.string().regex(/^[0-9a-f]{64}$/),
        expiresAt: z.iso.datetime(),
    }),
    z.object({
        status: z.enum([
            McpRedemptionStatus.Pending,
            McpRedemptionStatus.Denied,
            McpRedemptionStatus.Expired,
            McpRedemptionStatus.Consumed,
        ]),
    }),
]);
//# sourceMappingURL=endpoints.js.map